import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-rating-badge',
    templateUrl: './rating-badge.component.html',
    styleUrls: ['./rating-badge.component.css'],
    standalone: false
})
export class RatingBadgeComponent implements OnInit {

  @Input() averageRate?: number;
  @Input() big: boolean = false;
  @Input() small = false;

  constructor() { }

  ngOnInit() {
  }

}